import { render } from "./SimilarProperties.vue?vue&type=template&id=71a197d9"
import script from "./SimilarProperties.vue?vue&type=script&lang=js"
export * from "./SimilarProperties.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__